module.exports = __webpack_public_path__ + "static/media/204.c31ef556.svg";